import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight, faTimes } from '@fortawesome/pro-light-svg-icons'

import { Box } from '@domain-group/suit-theme'

import type { UseCarouselPayload } from '@hooks/useCarousel'

import styles from './styles.module.scss'

const iconProps = {
  alignItems: 'center',
  backgroundColor: 'darkGrey',
  borderRadius: 5,
  color: 'white',
  fontSize: 'xxxlarge',
  height: 30,
  justifyContent: 'center',
  opacity: 0.8,
  position: 'absolute',
  top: '50%',
  width: 30,
  zIndex: 5,
} as const

type CarouselControlsProps = {
  callbacks?: { closeCarousel?: () => void },
  carouselPayload: UseCarouselPayload,
}

const CarouselControls = (props: CarouselControlsProps) => {
  const {
    callbacks,
    carouselPayload,
  } = props

  const { closeCarousel } = callbacks || {}

  const {
    callbacks: { selectNext, selectPrevious },
    canSelectNext,
    canSelectPrevious,
  } = carouselPayload

  return (
    <>
      {closeCarousel && (
        <Box
          {...iconProps}
          className={styles.button}
          right={16}
          top={16}
          style={{ cursor: 'pointer' }}
          onClick={() => closeCarousel()}
        >
          <FontAwesomeIcon icon={faTimes} />
        </Box>
      )}

      {canSelectPrevious && (
        <Box
          {...iconProps}
          className={styles.button}
          left={16}
          style={{ cursor: 'pointer', transform: 'translateY(-50%)' }}
          onClick={() => selectPrevious()}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </Box>
      )}

      {canSelectNext && (
        <Box
          {...iconProps}
          className={styles.button}
          right={16}
          style={{ cursor: 'pointer', transform: 'translateY(-50%)' }}
          onClick={() => selectNext()}
        >
          <FontAwesomeIcon icon={faAngleRight} />
        </Box>
      )}
    </>
  )
}
export default CarouselControls
